import { simpleSet } from '@r/reducers/utils';

const setCalculationModeShippingCostOptions = simpleSet as
  redux.reducers.calculationMode.settings.information.shippingCost.options;

export const options = setCalculationModeShippingCostOptions(
  'SET_CALCULATION_MODE_SHIPPING_COST_OPTIONS',
  []
);
